exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#createPasswordPage .userEmail{margin:15px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/less-loader!./pages/xo-create-password/styles.less
 ** module id = 455
 ** module chunks = 1
 **/